
// Tracks whether the full Forminator form was submitted successfully
let cashModalFormSubmitted = false;

// Phone captured when the modal opens from the teaser form
let cashModalPhone = '';

// Listen for Forminator's success event on form 1255
document.addEventListener('forminator:form:submit:success', function(e) {
    if (e.detail && e.detail.formId == 1255) {
        cashModalFormSubmitted = true;
    }
});

// Fallback: Forminator also fires a jQuery event
$(document).on('forminator:form:submit:success', function(e, formId) {
    if (formId == 1255) {
        cashModalFormSubmitted = true;
    }
});

window.openCashModal = function(btn, isTeaserForm = false) {
    // Reset state each time the modal opens
    cashModalFormSubmitted = false;

    if (isTeaserForm) {
        cashModalPhone = btn.closest('.get-cash-now-teaser-form').querySelector('input[type="tel"]').value;
    }

    document.getElementById('cash-modal-overlay').classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (isTeaserForm && cashModalPhone) {
        setTimeout(function() {
            const phoneField = document.querySelector(
                '#cash-modal-overlay input[name*="phone"], ' +
                '#cash-modal-overlay input[type="tel"]'
            );
            if (phoneField) {
                phoneField.value = cashModalPhone;
                phoneField.dispatchEvent(new Event('input', { bubbles: true }));
                phoneField.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }, 150);
    }
}

$('.trigger-cash-offer-form').on('click', function () {
    openCashModal();
})

function doCloseModal() {
    // If the form wasn't fully submitted and we have a phone number, send partial lead
    if (!cashModalFormSubmitted && cashModalPhone && typeof partialLeadData !== 'undefined') {
        // Detect the Forminator phone field name from the DOM
        const phoneField = document.querySelector(
            '#cash-modal-overlay input[name*="phone"], ' +
            '#cash-modal-overlay input[type="tel"]'
        );
        const fieldName = phoneField ? phoneField.name : 'phone-1';

        fetch(partialLeadData.ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action:     'submit_partial_lead',
                nonce:      partialLeadData.nonce,
                phone:      cashModalPhone,
                field_name: fieldName,
            }),
            keepalive: true, // ensures the request completes even if the page unloads
        });

        // Reset so we don't double-fire if the modal is reopened
        cashModalPhone = '';
    }

    document.getElementById('cash-modal-overlay').classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
}

window.closeCashModal = function(event) {
    // If clicking overlay background (not the modal box itself), close
    if (event && event.target !== document.getElementById('cash-modal-overlay')) return;
    doCloseModal();
}

// Also allow ESC key to close
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        doCloseModal();
    }
});
